var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex container-fluid h-screen w-full flex-row space-around",attrs:{"id":"app"}},[_c('Leftsidebar'),_c('Mainarea'),_c('Rightsidebar')],1)}
var staticRenderFns = []

export { render, staticRenderFns }